module.exports = [
  {
    path: '/',
    redirect: '/index',
  },

  {
    path: '/map',
    component: ()=>import('@/pages-yy/map/map'),
  },

  {
    path: '/login',
    component: ()=>import('@/pages-yy/login/login'),
  },

  {
    path: '/index',
    component: ()=>import('@/pages-yy/index/index'),
    hidden: true,
  },

  {
    path: '/index-rj',
    component: ()=>import('@/pages-yy/index-rj/index-rj'),
    hidden: true,
  },

  {
    path: '/index-xh',
    component: ()=>import('@/pages-yy/index-xh/index-xh'),
    hidden: true,
  },

  {
    path: '/index-about',
    component: ()=>import('@/pages-yy/index-about/index-about'),
    hidden: true,
  },
];
